import Vue from 'vue'
import Router from 'vue-router'

import PageNotFound from '@/pages/PageNotFound'

import routes from '@/pages/routes'
import { beforeEach } from './auth'

Vue.use(Router)

routes.push(
  {
    path: '*',
    component: PageNotFound,
    meta: {
      requiresAuth: true,
      title: 'pageNotFound.pageNotFound'
    }
  }
)

let router = new Router({
  routes
})

router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js